import { get } from 'lodash'

/**
 * 遞迴收集路由樹上所有 route name
 * @param {Array} routes
 * @returns {string[]}
 */
export function collectRouteNames (routes = []) {
  return routes.reduce((names, route) => {
    if (get(route, 'name')) names.push(route.name)
    if (get(route, 'children')) names.push(...collectRouteNames(route.children))
    return names
  }, [])
}

/**
 * 是否為店家層級頁面（需要已選定分店才能運作）
 *
 * 判斷依據：
 * - 組織層級頁面以 meta.scopeType === 'OrgId' 標示（含父層 route record）
 * - 登入、redirect、404、帳號設定等基本頁面來自 constantRoutes，不需要分店 context
 *
 * 店家層級頁面在沒有分店時，所有 /api-admin/:ShopId API 會以 shopId=null 發出 [CBGISSUE-259]
 *
 * @param {object} route 導航目標（vue-router Route，需含 matched）
 * @param {string[]} constantRouteNames 不需分店 context 的基本頁面名稱
 * @returns {boolean}
 */
export function isShopScopeRoute (route, constantRouteNames = []) {
  const matched = get(route, 'matched', [])
  // 無法判斷的路由（未匹配到任何 route record）不主動改變導向
  if (!matched.length) return false
  if (matched.some((one) => get(one, 'meta.scopeType') === 'OrgId')) return false
  return !matched.some((one) => constantRouteNames.includes(get(one, 'name')))
}
